// extracted by mini-css-extract-plugin
export default {"recaptcha":"styles_recaptcha__WMZmk"};